import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

const StyledLink = styled(Link)<{
  size?: 'sm' | 'md' | 'lg' | 'xs' | 'xxs' | 'xms';
  align?: 'center' | 'left' | 'right';
  variant?: 'primary' | 'secondary' | 'danger';
}>`
  font-family: Poppins;
  text-align: ${({ align }) => align || 'left'};
  text-decoration: underline;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: ${({ variant }) =>
    variant === 'danger'
      ? 'var(--white)'
      : variant === 'primary'
        ? 'var(--prim4)'
        : variant === 'secondary'
          ? 'var(--link2)'
          : 'var(--t-black)'};
  ${({ variant }) =>
    variant === 'danger' &&
    `background: var(--danger); padding: 4px 8px; border-radius: 4px;`};
  cursor: pointer;
  transition: color 0.3s ease;

  ${({ size }) => {
    switch (size) {
      case 'lg':
        return `
          font-size: 32px;
          font-weight: 600;
          line-height: 48px;
        `;
      case 'md':
        return `
          font-size: 24px;
          font-weight: 500;
          line-height: 36px;
        `;
      case 'sm':
        return `
          font-size: 16px;
          font-weight: 400;
          line-height: 24px;
        `;
      case 'xs':
        return `
          font-size: 14px;
          font-weight: 400;
          line-height: 21px;
        `;
      case 'xms':
        return `
          font-size: 12px;
          font-weight: 400;
          line-height: 15px;
        `;
      case 'xxs':
        return `
          font-size: 10px;
          font-weight: 400;
          line-height: 15px;
        `;
      default:
        return `
          font-size: 16px;
          font-weight: 400;
          line-height: 24px;
        `;
    }
  }}

  &:hover {
    color: ${({ variant }) =>
      variant === 'danger'
        ? 'var(--white)'
        : variant === 'primary'
          ? 'darken(var(--prim4), 10%)'
          : variant === 'secondary'
            ? 'darken(var(--link2), 10%)'
            : 'var(--t-black)'};
  }
`;

export default StyledLink;
